import {SkeletonBox} from '@primer/react'
import {clsx} from 'clsx'

import styles from './ToolbarButtonSkeleton.module.css'

type ToolbarButtonSkeletonProps = {
  /** Width of the placeholder; match the button it stands in for. */
  width: string
  /** Defaults to the 32px height of the medium toolbar selectors. */
  height?: string
  /** Forwarded so the placeholder keeps the loaded control's layout (e.g. spacing). */
  className?: string
  'aria-label'?: string
  'data-testid'?: string
}

/**
 * Placeholder shown in place of a task-input toolbar button while its data loads, so every
 * loadable control in the toolbar shares a single loading visual.
 */
export function ToolbarButtonSkeleton({width, height = '32px', className, ...rest}: ToolbarButtonSkeletonProps) {
  // SkeletonBox renders a plain <div> (generic role), which cannot be named by aria-label.
  // Give labeled placeholders a status role so assistive tech announces the loading message.
  const role = rest['aria-label'] ? 'status' : undefined
  return (
    <SkeletonBox
      width={width}
      height={height}
      role={role}
      className={clsx(styles.ToolbarButtonSkeleton, className)}
      {...rest}
    />
  )
}
